import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { config } from "../src/utils/config";

//import Cookies from "js-cookie";
import * as Cookies from 'js-cookie'

var csv = require('jquery-csv');

import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
    storage: window.sessionStorage
})

Vue.use(Vuex)

const store = new Vuex.Store({
    // plugins: [createPersistedState({
    //     key: 'somekey',
    //     storage: window.sessionStorage, //localStorage
    // })],
    // plugins: [
    //     createPersistedState({
    //       storage: {
    //         getItem: (key) => Cookies.get(key),
    //         setItem: (key, value) =>
    //           Cookies.set(key, value, { expires: 3, secure: true }),
    //         removeItem: (key) => Cookies.remove(key)
    //       }
    //     })
    //   ],
    //plugins: [createPersistedState()],

    plugins: [vuexLocal.plugin],
    // plugins: [
    //     createPersistedState({
    //         storage: {
    //             getItem: (key) => Cookies.get(key),
    //             // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
    //             setItem: (key, value) =>
    //               Cookies.set(key, value, { expires: 3, secure: true }),
    //             removeItem: (key) => Cookies.remove(key),
    //           },
    //     })
    //   ],
    state: {
        urlCache: {}, // Url => Obj

        strumenti: [],
        esperimenti: [],
        POIpivot: [],
        interests: [], //interessi inseriti in una struttura consona per le checkbox

        interestsObject: [], //interessi ricevuti da omeka
        activityType: [],
        activityTypeOmeka: [], //interessi ricevuti da omeka

        timelines: [],
        events: [],
        expertiseLevels: [],
        // schoolLevels: [],
        difficultyLevels: [],
        itinerari: [],
        POI: [],
        aree: [],

        startPointsForEachArea: [],
        selectedStartPointForEachArea: [],


        selectedLunchPoint: null,
        positionIndexForLunch: null,
        travellingTimeFromPoiBeforeLunchToLunch: null, //in millisecondi
        travellingTimeFromLunchToPoiAfterLunch: null, //in millisecondi

        setActivitiesInPOIdone: false,

        preferredPartOfDay: null,

        loadedActivitiesInPOIPivot: false,
        timeAvailable: null,

        oldTimeAvailable: null, //utile per capire se l'utente diminuisce il tempo che aveva messo a disposizione

        itinerarioInCreazione: null,
        totalTimeSelected: 0,

        remainingTimeAvailable: 0,

        itinerarioPredefinito: sessionStorage.getItem('itinerarioPredefinito'),

        areasWithSomethingSelected: [],

        // availableActivitiesInRemainingTime: [],

        sottoitinerari: [],

        activitiesSelectedList: [],
        // activitiesSelectedListJSON: "[{}]",

        selectedAreaCreateItinerary: null,
        selectedDifficultyFilter: null,
        selectedStartPoint: null,

        partOfDaySelectedRadio: "mattina",

        isMobile: false,

        timeSlotRadio: null,

        media: {
            mediaEsperimenti: [],
        },

        costMatricesTimeBetweenPOI: null,
        vroomCostMatricesTimeBetweenPOI: null,
        costMatricesTimeBetweenAreas: null,

        allDifficultiesStore: [],
        allInterestsStore: [],
        allActivityTypesStore: [],

        ambitiScientificiAttivita: [],
        ambitiScientificiStrumenti: [],
        ambitiScientificiOmeka: [],
        allAmbitiScientificiStore: [],

        allActivitiesLoaded: false,

        itineraryCode: null,

        viewFeaturesProgettoTesi: false,

        veichle: "Auto",
        lunchType: "Ristorante",

        customTimeSlot: null,

        currentStepChooseStartPoint: 0,

        customTimeWindow: {
            startHH: 0,
            startMM: 0,
            endHH: 0,
            endMM: 0
        }
    },
    mutations: {
        increment(state) {
            state.count++
        },

        setStartPointsArray(state, { startPoints, currentStep }) {
            state.startPointsForEachArea[currentStep] = startPoints;
        },

        setSelectedStartPointsArray(state, { point, currentStep }) {
            state.selectedStartPointForEachArea[currentStep] = point;
        },

        setCurrentStepChooseStartPoint(state, { currentStep }) {
            state.currentStepChooseStartPoint = currentStep;
        },

        setTravellingTimeFromPoiBeforeLunchToLunch(state, { travellingTimeFromPoiBeforeLunchToLunch }) {
            state.travellingTimeFromPoiBeforeLunchToLunch = travellingTimeFromPoiBeforeLunchToLunch;
        },

        setTravellingTimeFromLunchToPoiAfterLunch(state, { travellingTimeFromLunchToPoiAfterLunch }) {
            state.travellingTimeFromLunchToPoiAfterLunch = travellingTimeFromLunchToPoiAfterLunch;
        },

        positionIndexForLunch(state, { positionIndexForLunch }) {
            state.positionIndexForLunch = positionIndexForLunch;
        },

        setSelectedLunchPoint(state, { selectedLunchPoint }) {
            state.selectedLunchPoint = selectedLunchPoint;
        },

        setSelectedStartPointNew(state, { value }) {
            state.selectedStartPointForEachArea = value;
        },

        setSelectedStartPointForEachArea(state, { currentStep, value }) {
            state.selectedStartPointForEachArea[currentStep] = value;
        },

        setCustomTimeSlot(state, { customTimeSlot }) {
            state.customTimeSlot = customTimeSlot;
        },

        setSelectedArea(state, { areaTitle }) {
            state.selectedAreaCreateItinerary = areaTitle;
        },

        setSelectedDifficultyFilter(state, { difficultyName }) {
            state.selectedDifficultyFilter = difficultyName;
        },

        setPartOfDaySelectedRadio(state, { partOfDaySelectedRadio }) {
            state.partOfDaySelectedRadio = partOfDaySelectedRadio;
        },

        setSelectedStartPoint(state, { startPoint }) {
            state.selectedStartPoint = startPoint;
        },

        setTimeSlotRadio(state, { timeSlotRadio }) {
            state.timeSlotRadio = timeSlotRadio;
        },

        addActivityToSelectedList(state, { activityTmp }) {
            state.activitiesSelectedList.unshift(activityTmp);
        },

        removeActivityFromSelectedList(state, { indexOfActivity }) {
            state.activitiesSelectedList.splice(indexOfActivity, 1);
        },

        setAllactivityType(state) {
            if (state.activityType.length === 0) {
                // in questo modo non ho interessi duplicati, ma solo una voce unica per ognuno

                Array.prototype.forEach.call(state.activityTypeOmeka, i => {
                    state.activityType.push({
                        activityTypeName: i['o:title'],
                        activityTypeSelected: false
                    })
                })
            }

            if (state.allActivityTypesStore.length === 0) {
                Array.prototype.forEach.call(state.activityTypeOmeka, i => {
                    state.allActivityTypesStore.push(i['o:title'])
                })
            }
        },


        setAllAmbitiScientificiStrumenti(state) {
            if (state.ambitiScientificiStrumenti.length === 0) {
                // in questo modo non ho interessi duplicati, ma solo una voce unica per ognuno

                Array.prototype.forEach.call(state.ambitiScientificiOmeka, i => {
                    state.ambitiScientificiStrumenti.push({
                        ambitoScientificoName: i['o:title'],
                        ambitoScientificoSelected: false
                    })
                })
            }

            if (state.allAmbitiScientificiStore.length === 0) {
                Array.prototype.forEach.call(state.ambitiScientificiOmeka, i => {
                    state.allAmbitiScientificiStore.push(i['o:title'])
                })
            }
        },

        setAllAmbitiScientificiAttivita(state) {

            if (state.ambitiScientificiAttivita.length === 0) {
                // in questo modo non ho interessi duplicati, ma solo una voce unica per ognuno

                Array.prototype.forEach.call(state.ambitiScientificiOmeka, i => {
                    state.ambitiScientificiAttivita.push({
                        ambitoScientificoName: i['o:title'],
                        ambitoScientificoSelected: false
                    })
                })
            }

            if (state.allAmbitiScientificiStore.length === 0) {
                Array.prototype.forEach.call(state.ambitiScientificiOmeka, i => {
                    state.allAmbitiScientificiStore.push(i['o:title'])
                })
            }
        },

        setAllinterestOfPOI(state) {
            if (state.interests.length === 0) {
                // in questo modo non ho interessi duplicati, ma solo una voce unica per ognuno

                var didattico = store.state.interestsObject.filter(interest => interest["o:title"] === "Didattico");
                var scientifico = store.state.interestsObject.filter(interest => interest["o:title"] === "Scientifico");
                var divulgativo = store.state.interestsObject.filter(interest => interest["o:title"] === "Divulgativo");

                state.interests.push({
                    interestName: didattico[0]['o:title'],
                    interestSelected: false
                });
                state.interests.push({
                    interestName: scientifico[0]['o:title'],
                    interestSelected: false
                });
                state.interests.push({
                    interestName: divulgativo[0]['o:title'],
                    interestSelected: false
                });

                Array.prototype.forEach.call(state.interestsObject, i => {
                    if (i["o:title"] !== "Didattico" && i["o:title"] !== "Scientifico" && i["o:title"] !== "Divulgativo") {

                        state.interests.push({
                            interestName: i['o:title'],
                            interestSelected: false
                        })
                    }
                })
            }

            if (state.allInterestsStore.length === 0) {
                Array.prototype.forEach.call(state.interestsObject, i => {
                    state.allInterestsStore.push(i['o:title'])
                })
            }
        },

        setAllExpertiseLevels(state) {
            if (state.expertiseLevels.length === 0) {
                // in questo modo non ho interessi duplicati, ma solo una voce unica per ognuno
                //var expertiseLevels = [...new Set(state.esperimenti.map(x => x["geo:ha_difficolta"]["display_title"]))];

                Array.prototype.forEach.call(state.difficultyLevels, i => {
                    state.expertiseLevels.push({
                        expertiseLevelName: i['o:title'],
                        expertiseLevelSelected: false
                    })
                })
            }

            if (state.allDifficultiesStore.length === 0) {
                Array.prototype.forEach.call(state.difficultyLevels, i => {
                    state.allDifficultiesStore.push(i['o:title'])
                })
            }
        },

        setAllExpertiseLevelsOLD(state) {
            if (state.expertiseLevels.length === 0) {
                // in questo modo non ho interessi duplicati, ma solo una voce unica per ognuno
                var expertiseLevels = [...new Set(state.esperimenti.map(x => x["geo:ha_difficolta"]["display_title"]))];

                Array.prototype.forEach.call(expertiseLevels, i => {
                    state.expertiseLevels.push({
                        expertiseLevelName: i,
                        expertiseLevelSelected: false
                    })
                })
            }
        },

        setCustomTimeWindow(state, { startHH, startMM, endHH, endMM }) {
            state.customTimeWindow = {
                startHH: startHH,
                startMM: startMM,
                endHH: endHH,
                endMM: endMM
            }
        },

        setAvailableActivitiesInRemainingTime(state, { activityInItinerary, remainingTime }) {
            state.availableActivitiesInRemainingTime = state.POIpivot;

            //ciclo tutti i POI
            Array.prototype.forEach.call(state.availableActivitiesInRemainingTime, poiPivot => {

                var hasActivitiesInItinerary = false;
                var hasActivitiesAvailableForRemainingTime = false;

                Array.prototype.forEach.call(poiPivot.mis, attivita => {
                    //l'attività è nell'itinerario se il suo nome è contenuto in activityInItinerary
                    attivita.insertedInItinerary = activityInItinerary.includes(attivita["o:title"]);

                    if (attivita.insertedInItinerary) {
                        //se un'attività del poi è n itinerario allora il poi ha delle attività inserite nell'itinerario
                        hasActivitiesInItinerary = true;
                    }

                    //se il poi ha un'attività non inserita nell'itinerario la cui durata è minore del tempo a disposizione
                    if ((parseInt(attivita["geo:Durata"][0]["@value"]) * 60000 < remainingTime) && !attivita.insertedInItinerary) {
                        //allora il poi ha delle attività disponibili da scegliere nel tempo a disposizione
                        hasActivitiesAvailableForRemainingTime = true;
                    }
                })

                poiPivot.hasActivitiesInItinerary = hasActivitiesInItinerary;
                poiPivot.hasActivitiesAvailableForRemainingTime = hasActivitiesAvailableForRemainingTime;

            })
        },

        setActivitiesInPOIPivot(state) {
            /*
            * cosa vorrei:
            * POI 1:
            *   - attività 1
            *   - attività 2
            *   - attività 3
            * POI 2:
            *   - attività 1
            *  POI 3:
            *   - attività 1
            *   - attività 2
            * */

            Array.prototype.forEach.call(state.POIpivot, i => {
                var misurazioni = state.esperimenti.filter(x => x["geo:situato_in"][0]["value_resource_id"] === i["o:id"]);

                //Per ogni attività metto che non è selezionata di default
                Array.prototype.forEach.call(misurazioni, attivita => {
                    attivita.selected = false;

                    //attributo usato per mostrare o meno l'attività sulla vista
                    Vue.set(attivita, 'activityVisibleWithInterestsFilters', true);
                    Vue.set(attivita, 'activityVisibleWithDifficultiesFilters', true);
                    Vue.set(attivita, 'activityVisibleWithActivityTypeFilters', true);

                    // attivita.activityVisibleWithInterestsFilters = true;
                    // attivita.activityVisibleWithDifficultiesFilters = true;
                    // attivita.activityVisibleWithActivityTypeFilters = true;

                    attivita.durataMillisecondi = attivita["geo:Durata"][0]["@value"] * 60000; //converto i minuti in millisecondi
                })

                if (i.mis === undefined) {
                    i.mis = misurazioni;
                    //Vue.set(i, 'mis', misurazioni);

                }

                //attributo usato per mostrare o meno il poi sulla vista
                Vue.set(i, 'poiVisibleWithFilters', true);

                //attributo usato per sapere se ci sono attività selezionate in questo POI
                Vue.set(i, 'poiHasActivitiesSelected', true);

                //attributo usato per sapere se ci sono delle attività visibili
                Vue.set(i, 'poiHasSomeActivitiesVisible', true);

            })

            state.allActivitiesLoaded = true;
        },

        setActivitiesInPOI(state) {
            var undefinedPresent = false;
            Array.prototype.forEach.call(state.POIpivot, pivot => {
                if (pivot.mis === undefined) {
                    undefinedPresent = true;
                }
            })

            if (undefinedPresent) {
                this.commit("setActivitiesInPOIPivot")
            }

            /*
            * cosa vorrei:
            * POI 1:
            *   - attività 1
            *   - attività 2
            *   - attività 3
            * POI 2:
            *   - attività 1
            *  POI 3:
            *   - attività 1
            *   - attività 2
            * */

            Array.prototype.forEach.call(state.POIpivot, pivot => {
                var misurazioniInPivot = pivot.mis;
                var poiInPivot = state.POI.filter(poi => poi["geo:appartiene_a_pivot"][0]["value_resource_id"] === pivot["o:id"]);

                Array.prototype.forEach.call(poiInPivot, poi => {
                    //recupero i poi che appartengono all'itinerario corrente
                    if (poi.activitiesOfPOIPivot === undefined) {
                        poi.activitiesOfPOIPivot = misurazioniInPivot;
                    }
                    if (poi.marker === undefined) {
                        poi.marker = pivot.marker;
                    }

                    poi.media = pivot.media;

                    poi.areaDiAppartenenza = pivot["geo:appartiene_a_area"];

                    poi['geo:Durata'] = pivot['geo:Durata'];
                    poi['geo:Scheda_esterna'] = pivot['geo:Scheda_esterna'];

                    poi['dcterms:description'] = pivot['dcterms:description'];
                })
            })

            this.setActivitiesInPOIdone = true;
        },

        setTimelines(state) {
            Array.prototype.forEach.call(state.timelines, i => {
                i.events = state.events.filter(x => x["geo:appartiene_a_timeline"][0]["value_resource_id"] === i["o:id"]);
            })
        },

        initCostMatrixPOI() {
            if (store.state.costMatricesTimeBetweenPOI === null) {
                var matrixCostBetweenPOI = store.state.omekaCsvMatrixes.filter(matrix => matrix['o:title'] === 'SpostamentiTraPOI')[0];
                var initialCsv = matrixCostBetweenPOI['geo:Valore'][0]['@value'];

                // break the textblock into an array of lines
                var lines = initialCsv.split('\n');
                // remove one line, starting at the first position
                lines.splice(0, 1);
                // join the array back into a single string
                var finalCsv = lines.join('\n');

                var object = csv.toObjects(finalCsv);

                Array.prototype.forEach.call(object, (arr) => {
                    for (const property in arr) {
                        if (property !== "PoiID" && property !== "PoiName" && property !== "AreaDiAppartenenza" && arr[property] !== "-1") {
                            arr[property] = parseInt(arr[property]) * 60000;
                        } else if (arr[property] === "-1") {
                            arr[property] = config.omekaIDs.defaultTravelTimeBetweenPOIs * 60000;  //per VROOM la matrice deve avere tutti valori >= 0
                        }
                    }
                });

                store.state.costMatricesTimeBetweenPOI = object;
                store.state.costMatricesTimeBetweenPOI = store.state.costMatricesTimeBetweenPOI.sort((a, b) => parseInt(a.PoiID) - parseInt(b.PoiID))

                if (store.state.vroomCostMatricesTimeBetweenPOI === null) {
                    //creazione matrice con i costi da passare a VROOM
                    var matrix = [];

                    var i = 0;
                    Array.prototype.forEach.call(store.state.costMatricesTimeBetweenPOI, (arr) => {
                        var array = [];

                        for (const property in arr) {
                            if (property !== "PoiID" && property !== "PoiName" && property !== "AreaDiAppartenenza") { //&& arr[property] !== "-1"
                                array.push(arr[property]);
                            } else if (arr[property] === "-1") {
                                array.push(0 * 60000);  //per VROOM la matrice deve avere tutti valori >= 0
                            }

                            //aggiungo un ultima colonna con un valore di default da usare quando la matrice non contiene il POI per qualche motivo
                        }

                        array.push(10 * 60000);

                        matrix.push(array);

                        i += 1;
                    });

                    var lengthOfRow = matrix[0].length;
                    var lastRow = new Array(lengthOfRow).fill(10 * 60000); //TODO: controllare che funzioni, ho modificato qua

                    matrix.push(lastRow);

                    store.state.vroomCostMatricesTimeBetweenPOI = matrix;

                }
            }
        },

        initCostMatrixAreas() {
            if (store.state.costMatricesTimeBetweenAreas === null) {
                var matrixCostBetweenAreas = store.state.omekaCsvMatrixes.filter(matrix => matrix['o:title'] === 'SpostamentiTraAree')[0];
                var initialCsv = matrixCostBetweenAreas['geo:Valore'][0]['@value'];

                // break the textblock into an array of lines
                var lines = initialCsv.split('\n');
                // remove one line, starting at the first position
                lines.splice(0, 1);
                // join the array back into a single string
                var finalCsv = lines.join('\n');

                var object = csv.toObjects(finalCsv);

                Array.prototype.forEach.call(object, (arr) => {
                    for (const property in arr) {
                        if (property !== "AreaName" && property !== "AreaID") {
                            arr[property] = parseInt(arr[property]) * 60000;
                        }
                    }

                });

                store.state.costMatricesTimeBetweenAreas = object;
            }
        },

        setItinerarioPredefinito(state, { itinerarioPredefinito }) {
            sessionStorage.setItem('itinerarioPredefinito', JSON.stringify(itinerarioPredefinito));

        },

        setItinerarioVROOM(state, { itinerarioVROOM }) {
            sessionStorage.setItem('itinerarioVROOM', JSON.stringify(itinerarioVROOM));
        },

        setPOIpivot(state, { POIpivot }) {
            sessionStorage.setItem('POIpivot', JSON.stringify(POIpivot));
        },

        removeOtherObjects(state) {
            state.strumenti = [];
            var urlStrumenti = "https://dev.geodidalab.unito.it/api/items?fulltext_search=&property[0][type]=eq&resource_class_id[]=123"
            state.urlCache[urlStrumenti] = undefined;

            var urlTimelines = "https://dev.geodidalab.unito.it/api/items?fulltext_search=&property[0][type]=eq&resource_class_id[]=124"
            state.urlCache[urlTimelines] = undefined;

            state.timelines = [];
            //sessionStorage.removeItem('timeline');
        },

        removePOIAndActivities(state) {
            var urlPOIpivot = "https://dev.geodidalab.unito.it/api/items?fulltext_search=&property[0][type]=eq&resource_class_id[]=121";
            state.POIpivot = [];
            state.urlCache[urlPOIpivot] = undefined;

            var urlAree = "https://dev.geodidalab.unito.it/api/items?fulltext_search=&property[0][type]=eq&resource_class_id[]=132";
            state.aree = [];
            state.urlCache[urlAree] = undefined;

            var urlEsperimenti = "https://dev.geodidalab.unito.it/api/items?fulltext_search=&property[0][type]=eq&resource_class_id[]=130";
            state.esperimenti = [];
            state.urlCache[urlEsperimenti] = undefined;

            var urlDifficolta = "https://dev.geodidalab.unito.it/api/items?fulltext_search=&property[0][type]=eq&resource_class_id[]=129";
            state.difficultyLevels = [];
            state.urlCache[urlDifficolta] = undefined;

            var urlInteressi = "https://dev.geodidalab.unito.it/api/items?fulltext_search=&property[0][type]=eq&resource_class_id[]=128";
            state.interestsObject = [];
            state.urlCache[urlInteressi] = undefined;

            var urlTipologiaAttivita = "https://dev.geodidalab.unito.it/api/items?fulltext_search=&property[0][type]=eq&resource_class_id[]=131";
            state.activityTypeOmeka = [];
            state.urlCache[urlTipologiaAttivita] = undefined;
        },

        /* CACHE URL */
        addCachedUrl: (state, [url, payload]) => state.urlCache[url] = JSON.stringify(payload),
    },
    getters: {
        timelinesWithEvents: state => {
            Array.prototype.forEach.call(state.timelines, i => {

                var eventsTimeline = state.events.filter(x => x["geo:appartiene_a_timeline"][0]["value_resource_id"] === i["o:id"]);

                i.events = eventsTimeline;
            })

            return state.timelines;
        },

        selectedStartPointForEachArea: state => {
            return state.selectedStartPointForEachArea;
        },

        startPointsForEachArea: state => {
            return state.startPointsForEachArea;
        },

        activitiesSelectedList: state => {
            return state.activitiesSelectedList;
        },

        selectedAreaCreateItinerary: state => {
            return state.selectedAreaCreateItinerary;
        },

        selectedStartPoint: state => {
            return state.selectedStartPoint;
        },

        viewFeaturesProgettoTesi: state => {
            return false;
        },

        partOfDaySelectedRadio: state => {
            return state.partOfDaySelectedRadio;
        },

        timeSlotRadio: state => {
            return state.timeSlotRadio;
        },

        getPOIpivot: state => {
            return JSON.parse(sessionStorage.getItem('POIpivot'));
        },

        getCustomTimeSlot: state => {
            return state.customTimeSlot;
        },

        getPositionIndexForLunch: state => {
            return state.positionIndexForLunch;
        },

        getSelectedLunchPoint: state => {
            return state.selectedLunchPoint;
        },

        getTravellingTimeFromPoiBeforeLunchToLunch: state => {
            return state.travellingTimeFromPoiBeforeLunchToLunch;
        },

        getTravellingTimeFromLunchToPoiAfterLunch: state => {
            return state.travellingTimeFromLunchToPoiAfterLunch;
        },


        getCached: state => state.urlCache,

        timelines: state => state.timelines,

        getStartPointsOfSpecificArea(state) {
            var self = this;
            return function (args) {
                return state.startPointsForEachArea[args];
                // return data from store with query on args and self as this
            };
        }
    }
})

export default store;